import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { Link } from 'react-router-dom';
import { logEvent } from '../../utils/ga';
import styles from './ExpertCallout.module.css';

export interface ExpertCalloutProps {
  title: string;
  body: string;
  cta?: { label: string; href: string };
}

export function ExpertCallout({ title, body, cta }: ExpertCalloutProps) {
  return (
    <div className={styles.root}>
      <LightbulbOutlinedIcon className={styles.icon} />
      <div className={styles.content}>
        <p className={styles.title}>전문가 인사이트 — {title}</p>
        <p className={styles.body}>{body}</p>
        {cta && (
          <Link
            to={cta.href}
            className={styles.cta}
            onClick={() => logEvent('engagement', 'expert_callout_cta_click', cta.href)}
          >
            {cta.label} →
          </Link>
        )}
      </div>
    </div>
  );
}
